<template>
  <div class="page legal">
    <section class="legal-hero">
      <nav class="crumb">
        <router-link to="/home">首页</router-link>
        <span>/</span>
        <em>{{ content.title }}</em>
      </nav>
      <span class="eyebrow reveal" v-reveal>Legal</span>
      <h1 class="h2 legal-title reveal" v-reveal="{ delay: 60 }">{{ content.title }}</h1>
      <p class="legal-lead reveal" v-reveal="{ delay: 120 }">{{ content.lead }}</p>
      <p class="legal-updated">最近更新：{{ legal.updatedAt }}</p>
    </section>

    <section class="legal-body">
      <article v-for="(b, i) in content.blocks" :key="i" class="legal-block reveal" v-reveal="{ delay: (i % 3) * 60 }">
        <h2>{{ b.h }}</h2>
        <p v-for="(t, ti) in b.p" :key="ti">{{ t }}</p>
      </article>
    </section>

    <section class="legal-contact card card-pad reveal" v-reveal>
      <h3 class="legal-contact-title"><IconSvg name="phone"/> 联系方式</h3>
      <ul class="legal-contact-list">
        <li><span>电话</span><a :href="`tel:${company.phone}`">{{ company.phone }}</a></li>
        <li><span>邮箱</span><a :href="`mailto:${company.email}`">{{ company.email }}</a></li>
        <li><span>微信</span><em>微信搜索 {{ company.wechat.search }} 添加</em></li>
        <li><span>地址</span><em>{{ company.address }}</em></li>
      </ul>
      <div class="legal-actions">
        <router-link to="/contact" class="btn btn-primary">
          前往联系我们
          <IconSvg name="arrow-right"/>
        </router-link>
        <router-link :to="other.path" class="btn btn-ghost">{{ other.title }}</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import IconSvg from '@/components/common/IconSvg'
import { company, legal } from '@/data/site'

/**
 * 法律文本页（隐私政策 / 服务条款）：同一组件按 kind 渲染，内容取自 site.js 的 legal
 */
export default {
  name: 'LegalPage',
  components: { IconSvg },
  props: {
    kind: { type: String, default: 'privacy' }
  },
  data() {
    return { company, legal }
  },
  computed: {
    content() {
      return legal[this.kind] || legal.privacy
    },
    other() {
      return this.kind === 'privacy'
        ? { title: '查看服务条款', path: '/terms' }
        : { title: '查看隐私政策', path: '/privacy' }
    }
  }
}
</script>

<style lang="scss" scoped>
.legal {
  padding-top: 132px;
  padding-bottom: 80px;
  max-width: 900px;
}

.legal-hero {
  margin-bottom: 42px;

  .crumb {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 18px;
    font-size: 13px;
    color: var(--txt-3);

    a { color: var(--txt-2); }
    a:hover { color: var(--cyan); }
    em { font-style: normal; color: var(--txt-2); }
  }

  .legal-title { margin: 10px 0 14px; }

  .legal-lead {
    margin: 0 0 12px;
    font-size: 15.5px;
    line-height: 1.8;
    color: var(--txt-2);
  }

  .legal-updated { margin: 0; font-size: 13px; color: var(--txt-3); }
}

.legal-body {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.legal-block {
  padding-bottom: 28px;
  border-bottom: 1px solid var(--line);

  &:last-child { border-bottom: 0; padding-bottom: 0; }

  h2 {
    margin: 0 0 12px;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
  }

  p {
    margin: 0 0 10px;
    font-size: 14.8px;
    line-height: 1.85;
    color: var(--txt-2);

    &:last-child { margin-bottom: 0; }
  }
}

.legal-contact {
  --ico: 18px;
  margin-top: 46px;

  .legal-contact-title {
    display: flex;
    align-items: center;
    gap: 9px;
    margin: 0 0 16px;
    font-size: 17px;
    color: #fff;

    svg { color: var(--cyan); }
  }

  .legal-contact-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 26px;
    margin: 0 0 22px;
    padding: 0;
    list-style: none;

    li {
      display: flex;
      gap: 10px;
      align-items: baseline;
      font-size: 14.5px;

      span {
        min-width: 40px;
        font-size: 13px;
        color: var(--txt-3);
      }

      a { color: var(--txt); }
      a:hover { color: var(--cyan); }
      em { font-style: normal; color: var(--txt-2); }
    }
  }

  .legal-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
}

@media (max-width: 760px) {
  .legal { padding-top: 104px; }
  .legal-contact .legal-contact-list { grid-template-columns: 1fr; }
}
</style>
